import { render, staticRenderFns } from "./ArticleTabList.vue?vue&type=template&id=a33123e8&scoped=true&"
import script from "./ArticleTabList.vue?vue&type=script&lang=ts&"
export * from "./ArticleTabList.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleTabList.vue?vue&type=style&index=0&id=a33123e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33123e8",
  null
  
)

export default component.exports